import React from "react";
import ClarkMachineCard from "./clarkMachineCard";

const ReachTrucks = () => {
  return (
    <div className="w-full mt-5">
      <h4 className="mt-8 text-xl">Retrak</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-srx14-16.webp"
          imgAlt="Obrázek elektrického retraku CLARK srx14-16"
          title="CLARK série SRX14/16"
          loadCapacity="1 400 - 1 600 kg"
          drive="Elektrický"
          liftHeight="4 000 - 10 500 mm"
          maxSpeed="až 14 km/h"
          link="https://clarkmheu-com.translate.goog/en/reach-trucks/srx14-16?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
      </div>
    </div>
  );
};
export default ReachTrucks;
